/**
 * ToggleFilter — icon-based two-state toggle.
 * Extracted from FilterBar.jsx for reuse across filter configurations.
 */

export default function ToggleFilter({ options = [], value, onChange }) {
  return (
    <div
      style={{
        display: 'flex',
        gap: 0,
        borderRadius: 8,
        overflow: 'hidden',
        border: '1px solid var(--bdr)',
      }}
    >
      {options.map((opt) => {
        const active = value === opt.value;
        const Icon = opt.icon;
        return (
          <button
            key={opt.value}
            onClick={() => onChange(opt.value)}
            style={{
              padding: '8px 10px',
              background: active ? 'var(--navy)' : 'var(--glass)',
              color: active ? 'var(--card)' : 'var(--t2)',
              border: 'none',
              borderRight: '1px solid var(--bdr)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: 44,
              minWidth: 44,
            }}
          >
            {Icon ? <Icon size={16} strokeWidth={1.5} /> : opt.value}
          </button>
        );
      })}
    </div>
  );
}
